<section
  class="cdi-page-not-found"
  aria-labelledby="cdi-page-not-found-heading"
>
  <h1 id="cdi-page-not-found-heading">Page not found</h1>
  <p class="cdi-page-not-found-lead">We cannot find that page.</p>
  <p-button
    id="cdi-btn-customer-portal"
    label="Customer Portal"
    routerLink="/dashboard"
    size="large"
  />
  <p class="cdi-page-not-found-support">
    Need help? Call Cascade Designs at
    <a href="tel:8008274548">800-827-4548</a>
    or
    <a href="tel:206-505-9500">206-505-9500</a>.
  </p>
  <p class="cdi-page-not-found-code">404</p>
</section>
